/**
 * usePlayer — thin consumer of PlayerContext.
 * Keeps the exact same return shape as before so all existing callers work unchanged.
 */
import { usePlayerContext } from "../providers/PlayerProvider";

export default function usePlayer() {
  return usePlayerContext();
}
